<button [type]="type" [class.button--black]="color === 'black'" [class.button--focus]="color === 'focus'"
  [class.button--transparent]="color === 'transparent'" class="button p-1 w-full" (click)="clicked.emit()">
  <div class="w-full relative">
    <div class="absolute top-0 h-full w-full button__background"></div>
    <div class="w-full relative py-2 px-5">
      <ng-content></ng-content>
    </div>
  </div>
</button>